var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteHighlight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20h11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.5 20 11l-6.5 6.5-4.5-1 1-4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 6 6 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 15.5 2.5 2.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20 15.5-2.5 2.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteHighlight);
export default __webpack_public_path__ + "static/media/delete-highlight.ac4871537dfcfb57882816afa468655b.svg";
export { ForwardRef as ReactComponent };